import { useGetWorkspaceCode } from '~teacher/hook/workspaces/code';

import { WorkspaceRole } from '../../../../../api/workspaces/getWorkspaceMembers';
import { WorkspaceCode } from '../../../../../api/workspaces/invite/getWorkspaceCode';
import { inviteToWorkspaceURL } from '../../../../../api/workspaces/workspacesURLs';

function getAccessUrl({ code }: WorkspaceCode) {
  return code !== undefined ? inviteToWorkspaceURL(code).href : undefined;
}

interface UseInviteLinkParams {
  workspaceId: string;
  workspaceRole: WorkspaceRole;
}

export function useInviteLink({
  workspaceId,
  workspaceRole,
}: UseInviteLinkParams) {
  return useGetWorkspaceCode({
    workspaceId: workspaceId,
    workspaceRole: workspaceRole,
    select: ({ code }) => {
      return {
        url: getAccessUrl({ code }),
        isEnabled: code !== undefined,
      };
    },
  });
}
